// Product catalogue — 10 exclusive t-shirt designs.
// Postmodern Greek mythology drop. Images saved into public/products/.
export const COLORS = [
  { key: "black", name: "Μαύρο", hex: "#0A0A0A" },
  { key: "white", name: "Άσπρο", hex: "#FFFFFF" },
  { key: "yellow", name: "Κίτρινο", hex: "#FFD700" },
  { key: "beige", name: "Μπεζ", hex: "#E8DCC4" },
  { key: "green", name: "Πράσινο", hex: "#22C55E" },
];

export const PRODUCTS = [
  {
    id: "tee-01",
    title: "Love Never Dies",
    tag: "Drop 01",
    price: "24€",
    image: "/products/tee-01.png",
    desc: "Δύο σκελετοί φιλιούνται κάτω από την Ακρόπολη. Η αγάπη δεν πεθαίνει ποτέ.",
  },
  {
    id: "tee-02",
    title: "Αχιλλέας",
    tag: "Drop 02",
    price: "24€",
    image: "/products/tee-02.png",
    desc: "Ο αδάμαστος πολεμιστής και η θνητή του φτέρνα — μάρμαρο σε pop-art collage.",
  },
  {
    id: "tee-03",
    title: "Μέδουσα",
    tag: "Drop 03",
    price: "24€",
    image: "/products/tee-03.png",
    desc: "Η καταραμένη ομορφιά με τα φίδια. Ένα βλέμμα, μια πέτρα.",
  },
  {
    id: "tee-04",
    title: "Δίας",
    tag: "Drop 04",
    price: "24€",
    image: "/products/tee-04.png",
    desc: "Ο πατέρας των θεών με κεραυνό — μάρμαρο συναντά ηλεκτρισμό.",
  },
  {
    id: "tee-05",
    title: "Ποσειδώνας",
    tag: "Drop 05",
    price: "24€",
    image: "/products/tee-05.png",
    desc: "Ο βασιλιάς της θάλασσας ανάμεσα στα κύματα. Τρίαινα, glitch και αλμύρα.",
  },
  {
    id: "tee-06",
    title: "Ηρακλής",
    tag: "Drop 06",
    price: "24€",
    image: "/products/tee-06.png",
    desc: "Ο δυνατός ήρωας παλεύει το λιοντάρι της Νεμέας. Άθλος πρώτος — 10 να πάνε.",
  },
  {
    id: "tee-07",
    title: "Αθηνά",
    tag: "Drop 07",
    price: "24€",
    image: "/products/tee-07.png",
    desc: "Η θεά της σοφίας με κράνος και κουκουβάγια. Silent, sharp, superior.",
  },
  {
    id: "tee-08",
    title: "Ίκαρος",
    tag: "Drop 08",
    price: "24€",
    image: "/products/tee-08.png",
    desc: "Πέταξε πολύ κοντά στον ήλιο. Synthwave πτώση σε κίτρινο και ροζ.",
  },
  {
    id: "tee-09",
    title: "Μινώταυρος",
    tag: "Drop 09",
    price: "24€",
    image: "/products/tee-09.png",
    desc: "Το τέρας μέσα στον λαβύρινθο. Punk zine αισθητική, χαμένη έξοδος.",
  },
  {
    id: "tee-10",
    title: "Ερμής",
    tag: "Drop 10",
    price: "24€",
    image: "/products/tee-10.png",
    desc: "Ο αγγελιοφόρος με τα φτερωτά σανδάλια. Ταχύτητα και pop-art χρώμα.",
  },
];
